import foldIcon from '@/pages/dashboard/assets/svg/fold.svg';
import expandIcon from '@/pages/dashboard/assets/svg/expand.svg';
import './index.scss';
import React from 'react';
import { Segment } from 'tea-component';
import useData from './_hooks';

const segmentBtn = [
  {
    text: <img src={foldIcon} />,
    value: 'pre',
  },
  {
    text: <img src={expandIcon} />,
    value: 'next',
  },
];

function DateSeletor(props, ref) {
  const { onSelect } = props;
  const {
    timeListArray,
    value1,
    maxSegmentPage,
    dateNum,
    segmentPage,
    setSegmentPage,
    DateChange,
  } = useData({ props, ref });

  // 拼接Segment
  let optionList = [];
  if (segmentPage === 0 && segmentPage != maxSegmentPage - 1) {
    optionList = [
      ...timeListArray.slice(segmentPage * dateNum, segmentPage * dateNum + dateNum),
      segmentBtn[1],
    ];
  } else if (segmentPage === maxSegmentPage - 1 && segmentPage !== 0) {
    optionList = [
      segmentBtn[0],
      ...timeListArray.slice(segmentPage * dateNum, segmentPage * dateNum + dateNum),
    ];
  } else if (segmentPage != maxSegmentPage - 1 && segmentPage != 0) {
    optionList = [
      segmentBtn[0],
      ...timeListArray.slice(segmentPage * dateNum, segmentPage * dateNum + dateNum),
      segmentBtn[1],
    ];
  } else {
    optionList = timeListArray.slice(segmentPage * dateNum, segmentPage * dateNum + dateNum);
  }

  return (
    <div className="segment-flex dbi-trending-segment-flex" ref={ref}>
      <Segment
        className="segment-box"
        value={value1}
        onChange={(value: any) => {
          if (value === 'pre') {
            setSegmentPage(segmentPage - 1);
          } else if (value === 'next') {
            setSegmentPage(segmentPage + 1);
          } else {
            DateChange(value);
          }
          onSelect(value);
        }}
        options={optionList}
      />
    </div>
  );
}

export default DateSeletor;
